module.exports = __webpack_public_path__ + "static/img/logo_login_mmxp.6f8482ba.png";